import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth-context";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Layout } from "./pages/Layout";
import { CarteEditor } from "./pages/CarteEditor";
import { Questions } from "./pages/Questions";
import { ParcoursList } from "./pages/Parcours";
import { ParcoursEditor } from "./pages/ParcoursEditor";
import { SessionsList } from "./pages/Sessions";
import { SessionEditor } from "./pages/SessionEditor";
import { SessionDashboardPage } from "./pages/SessionDashboard";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const auth = useAuth();
  if (auth.status === "loading") return <div className="page-loading">Chargement…</div>;
  if (auth.status === "anon") return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<Navigate to="/carte" replace />} />
            <Route path="/carte" element={<CarteEditor />} />
            <Route path="/questions" element={<Questions />} />
            <Route path="/parcours" element={<ParcoursList />} />
            <Route path="/parcours/:id" element={<ParcoursEditor />} />
            <Route path="/sessions" element={<SessionsList />} />
            <Route path="/sessions/:id" element={<SessionEditor />} />
            <Route path="/sessions/:id/dashboard" element={<SessionDashboardPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
